import team1 from "../../images/team-1.png"
import team2 from "../../images/team-2.png"
import team3 from "../../images/team-3.png"
import team4 from "../../images/team-4.png"
import team5 from "../../images/team-5.png"
import team6 from "../../images/team-6.png"
import team7 from "../../images/team-7.png"
import team8 from "../../images/team-8.png"
import team9 from "../../images/team-9.png"
import team10 from "../../images/team-11.png"
import team11 from "../../images/team-12.png"
import team12 from "../../images/team-13.png"
import team13 from "../../images/team-14.png"
import team14 from "../../images/team-15.png"
import team15 from "../../images/team-16.png"

import { TbBrandInstagram } from "react-icons/tb";
import {
  TiSocialTwitter,
  TiSocialFacebook,
  TiSocialLinkedin,
} from "react-icons/ti";
import { FaTwitter, FaFacebookF, FaLinkedinIn ,FaInstagram } from "react-icons/fa";

export const InstructrsData = [
    {
        name : "Pr. Alexa Boss",
        title : "Assistant Director",
        img : team1,
        media : "Social Media",
        social : [
            {
                icon : <FaTwitter/>,
                path : ""
            },
            {
                icon : <FaFacebookF/>,
                path : "",
            },
            {
                icon : <FaLinkedinIn/>,
                path : ""
            },
            {
                icon : <FaInstagram/>,
                path : ""
            }
        ]
    },
    {
        name : "Dr. Adam Anderson",
        title : "Co-founder of company",
        img : team2,
        media : "Social Media",
        social : [
            {
                icon : <FaTwitter/>,
                path : ""
            },
            {
                icon : <FaFacebookF/>,
                path : "",
            },
            {
                icon : <FaLinkedinIn/>,
                path : ""
            },
            {
                icon : <FaInstagram/>,
                path : ""
            }
        ]
    },
    {
        name : "Dr. Sasha Davi",
        title : "Co-founder of compan",
        img : team3,
        media : "Social Media",
        social : [
            {
                icon : <FaTwitter/>,
                path : ""
            },
            {
                icon : <FaFacebookF/>,
                path : "",
            },
            {
                icon : <FaLinkedinIn/>,
                path : ""
            },
            {
                icon : <FaInstagram/>,
                path : ""
            }
        ]
    },
    {
        name : "Pr. Antonia Craighton",
        title : "Digital Marketer",
        img : team4,
        media : "Social Media",
        social : [
            {
                icon : <FaTwitter/>,
                path : ""
            },
            {
                icon : <FaFacebookF/>,
                path : "",
            },
            {
                icon : <FaLinkedinIn/>,
                path : ""
            },
            {
                icon : <FaInstagram/>,
                path : ""
            }
        ]
    },
    {
        name : "Pr. Marti Scorsese",
        title : "Course Researcher",
        img : team5,
        media : "Social Media",
        social : [
            {
                icon : <FaTwitter/>,
                path : ""
            },
            {
                icon : <FaFacebookF/>,
                path : "",
            },
            {
                icon : <FaLinkedinIn/>,
                path : ""
            },
            {
                icon : <FaInstagram/>,
                path : ""
            }
        ]
    },
    {
        name : "Pr. Olivia Woodson",
        title : "International Consultant",
        img : team6,
        media : "Social Media",
        social : [
            {
                icon : <FaTwitter/>,
                path : ""
            },
            {
                icon : <FaFacebookF/>,
                path : "",
            },
            {
                icon : <FaLinkedinIn/>,
                path : ""
            },
            {
                icon : <FaInstagram/>,
                path : ""
            }
        ]
    },
    {
        name : "Ketharin Craighton",
        title : "Digital Marketer",
        img : team7,
        media : "Social Media",
        social : [
            {
                icon : <FaTwitter/>,
                path : ""
            },
            {
                icon : <FaFacebookF/>,
                path : "",
            },
            {
                icon : <FaLinkedinIn/>,
                path : ""
            },
            {
                icon : <FaInstagram/>,
                path : ""
            }
        ]
    },
    {
        name : "Henny Sey",
        title : "English Teacher",
        img : team8,
        media : "Social Media",
        social : [
            {
                icon : <FaTwitter/>,
                path : ""
            },
            {
                icon : <FaFacebookF/>,
                path : "",
            },
            {
                icon : <FaLinkedinIn/>,
                path : ""
            },
            {
                icon : <FaInstagram/>,
                path : ""
            }
        ]
    },
    {
        name : "Thomas Woodson",
        title : "International Consultant",
        img : team9,
        media : "Social Media",
        social : [
            {
                icon : <FaTwitter/>,
                path : ""
            },
            {
                icon : <FaFacebookF/>,
                path : "",
            },
            {
                icon : <FaLinkedinIn/>,
                path : ""
            },
            {
                icon : <FaInstagram/>,
                path : ""
            }
        ]
    },
    {
        name : "Neil Tyson",
        title : "Teaches Communication",
        img : team10,
        media : "Social Media",
        social : [
            {
                icon : <FaTwitter/>,
                path : ""
            },
            {
                icon : <FaFacebookF/>,
                path : "",
            },
            {
                icon : <FaLinkedinIn/>,
                path : ""
            },
            {
                icon : <FaInstagram/>,
                path : ""
            }
        ]
    },
    {
        name : "Jessica Hische",
        title : "Teaches Interior Design",
        img : team11,
        media : "Social Media",
        social : [
            {
                icon : <FaTwitter/>,
                path : ""
            },
            {
                icon : <FaFacebookF/>,
                path : "",
            },
            {
                icon : <FaLinkedinIn/>,
                path : ""
            },
            {
                icon : <FaInstagram/>,
                path : ""
            }
        ]
    },
    {
        name : "Margaret Atwood",
        title : "Math Teacher",
        img : team12,
        media : "Social Media",
        social : [
            {
                icon : <FaTwitter/>,
                path : ""
            },
            {
                icon : <FaFacebookF/>,
                path : "",
            },
            {
                icon : <FaLinkedinIn/>,
                path : ""
            },
            {
                icon : <FaInstagram/>,
                path : ""
            }
        ]
    },
    {
        name : "Rosen Joun",
        title : "Photography Teacher",
        img : team13,
        media : "Social Media",
        social : [
            {
                icon : <FaTwitter/>,
                path : ""
            },
            {
                icon : <FaFacebookF/>,
                path : "",
            },
            {
                icon : <FaLinkedinIn/>,
                path : ""
            },
            {
                icon : <FaInstagram/>,
                path : ""
            }
        ]
    },

    {
        name : "Morin Boon",
        title : "Course Researcher",
        img : team14,
        media : "Social Media",
        social : [
            {
                icon : <FaTwitter/>,
                path : ""
            },
            {
                icon : <FaFacebookF/>,
                path : "",
            },
            {
                icon : <FaLinkedinIn/>,
                path : ""
            },
            {
                icon : <FaInstagram/>,
                path : ""
            }
        ]
    },
    {
        name : "Hosaifa Albenian",
        title : "Vice Principal",
        img : team15,
        media : "Social Media",
        social : [
            {
                icon : <FaTwitter/>,
                path : ""
            },
            {
                icon : <FaFacebookF/>,
                path : "",
            },
            {
                icon : <FaLinkedinIn/>,
                path : ""
            },
            {
                icon : <FaInstagram/>,
                path : ""
            }
        ]
    },



]